<template>
  <div>
    <div class="public-table-data">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        style="width: 100%"
        row-key="menuId"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column
          type="index"
          label="序号"
          min-width="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="adSite" label="位置" width="160" align="center">
        </el-table-column>

        <el-table-column prop="name" label="名称" width="200" align="center">
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="有效期"
          width="380"
          align="center"
        >
          <template slot-scope="scope">
            {{ `${scope.row.startTime} 至 ${scope.row.expireTime}` }}
          </template>
        </el-table-column>

        <el-table-column
          prop="eventType"
          label="事件"
          min-width="120"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="utime" label="时间" min-width="240" align="center" fixed="right">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageNo"
          :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
import { formatMoney } from "@utils/filters/filter";
export default {
  data() {
    return {
      total: 0,
      PAGE_SIZE,
      loading: false,
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [],
      formatMoney,
    };
  },
  created() {
    this.queryTableData();
  },
  methods: {
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const { data: resData } = await this.$get("ad/list", {
        params: {
          ...this.pages,
          status:1,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },
    handleSelectionChange(val) {
      this.$emit("childByValue", val);
       //清空选择
    // this.$nextTick(() => {
      for (var i = 0; i < this.$refs.multipleTable.length; i++) {
        this.$refs.multipleTable[i].clearSelection();
      }
    // });

    },
    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;
      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.queryTableData();
    },
  },
};
</script>
